module.exports = __webpack_public_path__ + "img/Dkterma-1138-655-310.6d78f17f.png";